import React, { useEffect } from "react";
import { ReactComponent as Android } from "../assets/images/Android.svg";
import { ReactComponent as Apple } from "../assets/images/Apple.svg";
import { ReactComponent as Ios } from "../assets/images/Ios.svg";
import { ReactComponent as Laptop } from "../assets/images/laptop.svg";
import { ReactComponent as Linux } from "../assets/images/linux.svg";
import { ReactComponent as Windows } from "../assets/images/Windows.svg";
import { PaddingRounded } from "@mui/icons-material";

export const chracterPosition = (alphabet) => {
  const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
  return positionOfAlphabet;
};

export const getTenantSlug = () => {
  try {
    const hostname = window?.location?.hostname || '';

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // ✅ Always prefer ?tenant= query param on localhost
      const params = new URLSearchParams(window.location.search);
      const tenantParam = params.get('tenant');
      if (tenantParam) return tenantParam;

      // fallback to path only for home page
      const pathParts = window.location.pathname.split('/');
      const viewIndex = pathParts.indexOf('view');
      const slug = pathParts[viewIndex + 1];

      const reservedWords = ['category', 'search', 'article'];
      const isMongoId = /^[a-f0-9]{24}$/i.test(slug);
      if (slug && !isMongoId && !reservedWords.includes(slug)) return slug;
      return '';
    }

    // production subdomain logic stays same
    const parts = hostname.split('.');
    if (parts.length < 3) return '';
    const subdomain = parts[0];
    const ignored = ['www', 'app', 'admin', 'beta'];
    if (ignored.includes(subdomain)) return '';
    return subdomain.toLowerCase();

  } catch (e) {
    return '';
  }
};

export const isKbSubdomain = () => {
  const hostname = window?.location?.hostname || '';
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  return !isLocal && !!getTenantSlug();
};
export const useScopedFontStyle = (scopeId, fontFamily) => {
  useEffect(() => {
    if (!scopeId || !fontFamily) return;
    const styleId = `kb-font-scope-${scopeId}`;

    let tag = document.getElementById(styleId);
    if (tag) tag.remove();

    tag = document.createElement("style");
    tag.id = styleId;
    tag.innerHTML = `
      [data-kb-font-id="${scopeId}"] .MuiTypography-root,
      [data-kb-font-id="${scopeId}"] .MuiButton-root,
      [data-kb-font-id="${scopeId}"] .MuiInputBase-root,
      [data-kb-font-id="${scopeId}"] .MuiInputLabel-root,
      [data-kb-font-id="${scopeId}"] .MuiFormLabel-root,
      [data-kb-font-id="${scopeId}"] .MuiOutlinedInput-input,
      [data-kb-font-id="${scopeId}"] .MuiInputBase-input,
      [data-kb-font-id="${scopeId}"] * {
        font-family: "${fontFamily}", Inter, sans-serif !important;
      }
    `;
    document.head.appendChild(tag);

    return () => {
      const el = document.getElementById(styleId);
      if (el) el.remove();
    };
  }, [scopeId, fontFamily]);
};
export const loadGoogleFont = (fontFamily) => {
  if (!fontFamily || fontFamily === 'Inter') return;
  const fontName = fontFamily.replace(/ /g, '+');
  const linkId = `google-font-${fontName}`;
  if (document.getElementById(linkId)) return;
  const link = document.createElement('link');
  link.id = linkId;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@300;400;500;600;700;800;900&display=swap`;
  document.head.appendChild(link);
};

export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const setFavicon = (iconURL) => {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  link.href = iconURL;
};

export const NewBadge = () => (
  <div style={{
    width: '48px', height: '24px', borderRadius: '5px',
    border: '1px solid #52C41A', background: '#F6FFED',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  }}>
    <span style={{ color: '#405261', fontFamily: 'Inter', fontSize: 12, fontWeight: 500, lineHeight: '18px' }}>New</span>
  </div>
)

export const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11.5 6V19" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 12.5H5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)


/** Online dot: socket presence (`isLive` from update_user_status), not message activity. */
export function visitorAppearsOnline(room) {
  if (!room || room.end_session) return false;
  return !!room.isLive;
}

export const msgTime = (time) => {
  if (time === undefined || time === null || time === "") return "—";
  const date = new Date(time);
  if (Number.isNaN(date.getTime())) return "—";
  const now = new Date();

  const isToday = date.toDateString() === now.toDateString();

  if (isToday) {
    return date.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } else {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const time = date.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${month} ${day}, ${year}  ${time}`;
  }
};

/**
 * Chat room list: prefer `latestMessageSnapshot` (new API); else populated `latestMessage` (legacy).
 * When `latestMessage` is only an id string, there is no inline body — use timestamps from the room.
 */
export const getRoomListPreviewFields = (room) => {
  if (!room || typeof room !== "object") {
    return {
      description: "",
      attachment: false,
      createdAt: null,
      sender_name: null,
    };
  }

  const snap = room.latestMessageSnapshot;
  if (snap && typeof snap === "object") {
    const content =
      snap.content != null && String(snap.content).trim() !== ""
        ? String(snap.content)
        : "";
    const hasFile = Boolean(snap.file_image);
    return {
      description: content,
      attachment: hasFile,
      createdAt: snap.createdAt || room.updatedAt || room.createdAt,
      sender_name: snap.sender_name ?? null,
    };
  }

  const lm = room.latestMessage;
  if (lm && typeof lm === "object" && !Array.isArray(lm)) {
    const content =
      lm.content != null && String(lm.content).trim() !== ""
        ? String(lm.content)
        : "";
    const hasFile = Boolean(lm.file_image || lm.fileImage);
    return {
      description: content,
      attachment: hasFile,
      createdAt: lm.createdAt || room.updatedAt || room.createdAt,
      sender_name: lm.sender_name || lm.senderName || null,
    };
  }

  return {
    description: "",
    attachment: false,
    createdAt: room.updatedAt || room.createdAt,
    sender_name: null,
  };
};

export const formatText = (text) => {
  const lines = text.split("\n");
  return lines.map((line, index) => {
    const [key, value] = line.split(": ");
    return (
      <React.Fragment key={index}>
        <span className="highlight">{key}:</span>
        <br />
        <span
          style={{
            wordBreak: "break-all",
            whiteSpace: "pre-wrap",
            display: "inline-block",
            maxWidth: "100%",
            textTransform: "lowercase",
          }}
        >
          {!value ? "{ no answer }" : value}
        </span>
        {index < lines.length - 1 && <br />}
        <br />
      </React.Fragment>
    );
  });
};

const LIST_ITEM_PATTERN = /^\s*(\d+\.|[-*+])\s+/;

const MAX_VISIBLE_SPACES = 2;

const capSpaceRun = (runLength) => {
  if (runLength <= 0) return "";
  if (runLength === 1) return " ";
  if (runLength <= MAX_VISIBLE_SPACES) {
    return ` ${"\u00A0".repeat(runLength - 1)}`;
  }
  return ` ${"\u00A0".repeat(MAX_VISIBLE_SPACES - 1)}`;
};

const preserveMultipleSpaces = (text) => {
  if (!text) return "";

  return text
    .split("\n")
    .map((line) =>
      line.replace(/^( *)(.*)$/u, (_, leadingSpaces, content) => {
        const cappedLeading = capSpaceRun(leadingSpaces.length);
        const normalizedContent = content.replace(
          / {2,}/g,
          (spaces) => capSpaceRun(spaces.length)
        );
        return `${cappedLeading}${normalizedContent}`;
      })
    )
    .join("\n");
};

export const normalizeMarkdownLists = (text) => {
  if (!text) return "";

  const lines = text.split("\n");
  const normalized = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    if (line.trim() === "") {
      const prevIsListItem =
        normalized.length > 0 &&
        LIST_ITEM_PATTERN.test(normalized[normalized.length - 1]);

      let nextNonEmptyIdx = i + 1;
      while (
        nextNonEmptyIdx < lines.length &&
        lines[nextNonEmptyIdx].trim() === ""
      ) {
        nextNonEmptyIdx++;
      }

      const nextIsListItem =
        nextNonEmptyIdx < lines.length &&
        LIST_ITEM_PATTERN.test(lines[nextNonEmptyIdx]);

      if (prevIsListItem && nextIsListItem) {
        continue;
      }
    }

    normalized.push(line);
  }

  return normalized.join("\n");
};

export const formatTicketMessageContent = (text) => {
  if (!text) return "";

  const normalized = normalizeMarkdownLists(
    text.replace(/\r\n/g, "\n").replace(/\r/g, "\n")
  );
  const parts = normalized.split(/(\[[^\]]+\]\([^)]+\))/g);

  return parts
    .map((part) => {
      if (/^\[[^\]]+\]\([^)]+\)$/.test(part)) {
        return part;
      }
      const withLinks = part.replace(/((?:https?:\/\/|www\.)[^\s]+)/g, (url) => {
        let trailing = "";
        if (/[.,?!:;)]$/.test(url)) {
          trailing = url.slice(-1);
          url = url.slice(0, -1);
        }
        let href = url;
        if (!/^https?:\/\//i.test(href)) {
          href = "https://" + href;
        }
        return `[${url}](${href})${trailing}`;
      });

      return preserveMultipleSpaces(withLinks);
    })
    .join("");
};

export const isValidHexColor = (color) => {
  return /^#([0-9A-F]{3}){1,2}$/i.test(color);
};

export const truncateMessage = (message) => {
  if (!message) return "No messages yet";
  let maxLength = 20;
  return message.length > maxLength
    ? `${message.slice(0, maxLength)}...`
    : message;
};

export const tabMapping = {
  "all-users": { tabIndex: 0, stateIndex: 0 },
  agents: { tabIndex: 1, stateIndex: 4 },
  "suspended-agents": { tabIndex: 3, stateIndex: 5 },
  chatbot: { tabIndex: 4, stateIndex: 2 },
  groups: { tabIndex: 5, stateIndex: 1 },
  "suspended-groups": { tabIndex: 6, stateIndex: 3 },
};

export const getTabParamFromIndex = (tabIndex) => {
  const entry = Object.entries(tabMapping).find(
    ([_, value]) => value.tabIndex === tabIndex
  );
  return entry ? entry[0] : "all-users";
};

export const msgTimeWithSeconds = (time) => {
  const date = new Date(time);
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const getDeviceIcon = (os, deviceType) => {
  const iconProps = { width: 24, height: 24 };

  if (deviceType === "mobile") {
    if (os.toLowerCase().includes("android")) return <Android {...iconProps} />;
    if (os.toLowerCase().includes("ios") || os.toLowerCase().includes("iphone"))
      return <Ios {...iconProps} />;
  }

  switch (os.toLowerCase()) {
    case "windows":
      return <Windows {...iconProps} />;
    case "macos":
    case "mac":
      return <Apple {...iconProps} />;
    case "linux":
      return <Linux {...iconProps} />;
    case "android":
      return <Android {...iconProps} />;
    case "ios":
      return <Ios {...iconProps} />;
    default:
      return <Laptop {...iconProps} />;
  }
};

export const getDeviceDisplayName = (browser, os, deviceType) => {
  const browserName = browser.charAt(0).toUpperCase() + browser.slice(1);
  const osName =
    os === "macos" ? "macOS" : os.charAt(0).toUpperCase() + os.slice(1);

  if (deviceType === "mobile") {
    if (os.toLowerCase().includes("android")) {
      let name = `${browserName} Mobile on Android`;
      if (name.startsWith("Mobile ")) {
        name = name.replace(/^Mobile\s+/, "");
      }
      return name;
    }
    if (os.toLowerCase().includes("ios")) {
      let name = `${browserName} Mobile on iPhone`;
      if (name.startsWith("Mobile ")) {
        name = name.replace(/^Mobile\s+/, "");
      }
      return name;
    }
  }

  return `${browserName} on ${osName}`;
};
export const getStatusStyle = (status) => {
  const baseStyle = {
    borderRadius: "5px",
    textAlign: "center",
    display: "inline-block",
    fontSize: "12px",
    fontWeight: "500",
    color: "#405261",
    lineHeight: "26px",
    height: "26px",
  };

  switch (status.toLowerCase()) {
    case "open":
      return {
        ...baseStyle,
        backgroundColor: "#F3FBFF",
        border: "1px solid #148DFD",
        width: "48px",
      };
    case "pending":
      return {
        ...baseStyle,
        backgroundColor: "#FFF7E6 ",
        border: "1px solid #FA8C16",
        width: "64px",
      };
    case "solved":
      return {
        ...baseStyle,
        backgroundColor: "#F6FFED",
        border: "1px solid #52C41A",
        width: "56px",
      };

    case "spam":
      return {
        ...baseStyle,
        backgroundColor: "#FFF1F0",
        border: "1px solid #FF4D4F",
        width: "46px",
      };
    default:
      return baseStyle;
  }
};

export function isValidEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

export const isLiveRoomOpen = (roomId) => {
  try {
    const url = new URL(window.location.href);
    const pathname = url.pathname.toLowerCase();
    const searchParams = url.searchParams;
    const onLiveSurface =
      pathname === "/live" || pathname === "/chat";
    return (
      onLiveSurface &&
      searchParams.has("roomId") &&
      searchParams.get("roomId") === roomId
    );
  } catch (e) {
    const path = window.location.pathname.toLowerCase();
    const match = path === "/live" || path === "/chat";
    const params = new URLSearchParams(window.location.search);
    return match && params.has("roomId") && params.get("roomId") === roomId;
  }
};

export const StatusDot = ({ status }) => {
  const getColor = () => {
    switch (status) {
      case "Chatting":
        return "#52C41A"; // green
      case "Queued":
        return "#B7C2CC"; // grey
      case "Browsing":
        return "#148DFD"; // blue
      case "Invited":
        return "#B7C2CC"; // grey
      default:
        return "#B7C2CC";
    }
  };

  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 6 6"
      fill="none"
      style={{ marginRight: "8px" }}
    >
      <circle cx="3" cy="3" r="3" fill={getColor()} />
    </svg>
  );
};

export const getActionButtonStyles = (actionType) => {
  const baseStyles = {
    width: "176px",
    height: "40px",
    borderRadius: "8px",
    boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
    textTransform: "none",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "18px",
  };

  switch (actionType) {
    case "green":
      return {
        ...baseStyles,
        backgroundColor: "#389E0D",
        color: "white",
        "&:hover": {
          backgroundColor: "#2d7a0a",
        },
      };
    case "blue":
      return {
        ...baseStyles,
        backgroundColor: "#148DFD",
        color: "white",
        "&:hover": {
          backgroundColor: "#0077CC",
        },
      };
    case "white":
      return {
        ...baseStyles,
        backgroundColor: "#FFF",
        color: "#405261",
        border: "1px solid #D5DCE1",
        "&:hover": {
          backgroundColor: '#ffffff',
          borderColor: '#c5ced6',
        },
      };
    default:
      return baseStyles;
  }
};

export const gridTemplateColumnsResponsive = {
  xs: "1fr",
  sm: "1fr",
  md: "minmax(200px,2fr) minmax(200px,2fr) minmax(200px,2fr) minmax(150px,1.2fr) minmax(150px,1.2fr) minmax(150px,1.2fr)",
};

export const getNiceScale = (maxValue, tickCount = 4) => {
  const v = Math.max(0, maxValue);
  // Charts render ticks[0..tickCount-1] and treat ticks[tickCount] as unlabeled headroom.
  // Size the scale so the highest *displayed* tick still covers the tallest bar.
  const visibleIntervals = Math.max(1, tickCount - 1);

  if (v === 0) {
    const step = 1;
    const max = step * tickCount;
    const ticks = Array.from({ length: tickCount + 1 }, (_, i) => i * step);
    return { max, ticks };
  }

  // Small-count auto range: start at step 2 (scale 0–8, visible top 6)
  // and bump the step until the highest displayed tick covers the data.
  if (v > 0 && v <= 12) {
    let step = 2;
    while (step * visibleIntervals < v) {
      step += 1;
    }
    const max = step * tickCount;
    const ticks = Array.from({ length: tickCount + 1 }, (_, i) => i * step);
    return { max, ticks };
  }

  // Desired rough step based on the visible axis (not the unlabeled top)
  const roughStep = v / visibleIntervals;

  // Find a nice step using 1-2-5 progression
  const pow10 = (n) => Math.pow(10, n);
  let exponent = Math.floor(Math.log10(roughStep));
  const base = roughStep / pow10(exponent);

  const candidates = [1, 2, 5, 10];
  let niceBase = candidates.find((c) => c >= base) ?? 10;
  let step = niceBase * pow10(exponent);

  // Prefer steps of 100 for percentage-like data (100-500 range)
  if (v >= 100 && v <= 500 && step === 50) {
    step = 100;
  }

  // Ensure the highest displayed tick covers the data
  while (step * visibleIntervals < v) {
    const idx = candidates.indexOf(niceBase);
    if (idx === -1 || idx === candidates.length - 1) {
      niceBase = 1;
      exponent += 1;
      step = niceBase * pow10(exponent);
    } else {
      niceBase = candidates[idx + 1];
      step = niceBase * pow10(exponent);
    }
  }

  const max = step * tickCount;
  const ticks = Array.from({ length: tickCount + 1 }, (_, i) => i * step);
  return { max, ticks };
};